import React from "react";
import PackedBubbleChart from "../../../../components/packed-bubble-chart/index";

const FemaleBodySpraysBubbleChart = () => {
  const options = {
    chart: {
      backgroundColor: "#F2F5F9",
      type: "packedbubble",
    },
    title: {
      text: "",
    },
    credits: {
      enabled: false,
    },
    legend: { enabled: false },
    colors: [
      "rgba(239, 91, 165, 1)",
      "rgba(239, 91, 165, 0.8)",
      "rgba(239, 91, 165, 0.6)",
      "rgba(239, 91, 165, 0.4)",
      "rgba(239, 91, 165, 0.2)",
    ],
    tooltip: {
      hideDelay: 0,
      useHTML: true,
      pointFormat:
        "<b>{point.name}:</b> {point.value}% <br /> <i>{point.valueShare}</i> ",
    },
    plotOptions: {
      packedbubble: {
        minPointLength: 1,
        marker: {
          lineColor: "transparent",
        },
        minSize: "40%",
        maxSize: "100%",
        layoutAlgorithm: {
          // splitSeries: false,
          // gravitationalConstant: 0.035,
          enableSimulation: false,
        },
        dataLabels: {
          enabled: true,
          format: "<b>{point.name}</b>",
          formatter: function () {
            if (this.y !== 0) {
              return this.y;
            }
          },
          filter: {
            property: "y",
            operator: ">",
            value: 0,
          },
          style: {
            fontSize: "14px",
            color: "#092f50",
            textOutline: "none",
            fontWeight: "normal",
            "word-break": "break-word",
            width: 50,
          },
        },
      },
    },
    series: [
      {
        stickyTracking: false,
        name: "Female Body Sprays",
        data: [{ name: "Impulse", value: 83, valueShare: "£1.1m" }],
      },
      {
        stickyTracking: false,
        name: "Female Body Sprays",
        data: [{ name: "Tiama", value: 10, valueShare: "£124k" }],
      },
      {
        stickyTracking: false,
        name: "Female Body Sprays",
        data: [{ name: "Insette", value: 3, valueShare: "£34k" }],
      },
      {
        stickyTracking: false,
        name: "Female Body Sprays",
        data: [{ name: "Charlie", value: 2, valueShare: "£25k" }],
      },
      {
        stickyTracking: false,
        name: "Female Body Sprays",
        data: [{ name: "Sanex", value: 1, valueShare: "£9k" }],
      },
    ],
  };

  return (
    <div className="page-wrapper">
      <div className="card">
        <div className="left-content">
          <p className="left-content-text">Female Body Sprays</p>
        </div>
        <div className="hr-line"></div>
        <div className="right-content">
          <p className="percentage">7%</p>
          <p className="right-content-text">of category</p>
        </div>
      </div>
      <PackedBubbleChart height={"100vh"} options={options} />
    </div>
  );
};

export default FemaleBodySpraysBubbleChart;
